
interface PopularVenue {
  id: string;
  name: string;
  location: string;
  region: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
}

// Popular venues for fallback search results
export const popularVenues: PopularVenue[] = [
  {
    id: "crypto-arena-la",
    name: "Crypto.com Arena",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.0430, longitude: -118.2673 }
  },
  {
    id: "hollywood-bowl-la",
    name: "Hollywood Bowl",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.1122, longitude: -118.3390 }
  },
  {
    id: "sofi-stadium-la",
    name: "SoFi Stadium",
    location: "Inglewood, CA",
    region: "Los Angeles",
    coordinates: { latitude: 33.9535, longitude: -118.3392 }
  },
  {
    id: "dodger-stadium-la",
    name: "Dodger Stadium",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.0739, longitude: -118.2400 }
  },
  {
    id: "staples-center-la",
    name: "Staples Center", // Some users still search by this name
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.0430, longitude: -118.2673 }
  },
  {
    id: "universal-studios-la",
    name: "Universal Studios Hollywood",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.1384, longitude: -118.3534 }
  },
  {
    id: "disneyland-anaheim",
    name: "Disneyland Resort",
    location: "Anaheim, CA",
    region: "Orange County",
    coordinates: { latitude: 33.8121, longitude: -117.9190 }
  },
  {
    id: "kia-forum-la",
    name: "Kia Forum",
    location: "Inglewood, CA",
    region: "Los Angeles",
    coordinates: { latitude: 33.9583, longitude: -118.3417 }
  },
  {
    id: "greek-theatre-la",
    name: "Greek Theatre",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.1186, longitude: -118.2951 }
  },
  {
    id: "banc-of-california-stadium-la",
    name: "BMO Stadium (Banc of California Stadium)",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.0122, longitude: -118.2851 }
  },
  {
    id: "walt-disney-concert-hall-la",
    name: "Walt Disney Concert Hall",
    location: "Los Angeles, CA",
    region: "Los Angeles",
    coordinates: { latitude: 34.0556, longitude: -118.2467 }
  },
  {
    id: "youtube-theater-la",
    name: "YouTube Theater",
    location: "Inglewood, CA",
    region: "Los Angeles",
    coordinates: { latitude: 33.9583, longitude: -118.3417 }
  }
];

// Helper function to search venues
export const searchVenues = (query: string): PopularVenue[] => {
  const lowercaseQuery = query.toLowerCase();
  return popularVenues.filter(
    venue => 
      venue.name.toLowerCase().includes(lowercaseQuery) || 
      venue.location.toLowerCase().includes(lowercaseQuery)
  );
};
